import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import React from 'react';
export var getChildren = function getChildren(children, displayName, equal) {
  return React.Children.toArray(children).filter(function (child) {
    return equal && child.type.displayName === displayName || !equal && child.type.displayName !== displayName;
  });
};